import React from 'react';

const About = () => {
  return (
    <>
      <div>
        <h2 className="text-white text-4xl mb-12">About</h2>
      </div>
      <div className="mx-auto max-w-xl">
        <img src="/assets/images/Coast2cLaFera.jpg" alt="Coast2P" />
        <p className="text-white justify-center -mt-5 ml-1 text-xs">
          Photo by Start Evil
        </p>
        <p className="text-white justify-center py-4">
          Coast2c is a Mexico City–based multimedia artist and modular
          synthesist known for her raw, exploratory approach to live electronic
          music. Drawing from techno, drone, and experimental sound design, she
          creates immersive sonic landscapes using a modular synthesis system as
          her primary instrument.
        </p>

        <p className="text-white justify-center py-4">
          Coast2c has performed live electronic sets across Europe and Latin
          America, with past appearances and workshops at MutekMX (Mexico City)
          Superbooth (Berlin), Synth Library (Prague), and HolaWave (Mexico
          City). Her recorded work has been released on labels including White
          Owl Records, Fauna Reve, DURO, TUTU Records, Ransom Note, Blankstairs,
          and Krater Music.
        </p>
        <p className="text-white justify-center py-4">
          A standout voice in Mexico’s modular synth scene, Coast2c brings a
          fierce, genre-defying vision to every performance—blurring the line
          between experimental performance and dancefloor impact.
        </p>

        <p className="text-white justify-center py-4">
          Coast2c&apos;s work includes sound design and music production. Her
          music has been released on a variety of labels including{' '}
          <a
            href="https://faunareve.com/album/morphism-incl-coast2mago-remix"
            target="_blank"
            rel="noreferrer"
          >
            Fauna Reve,
          </a>{' '}
          <a
            href="https://durolabel.com/track/dead-piano-original-mix"
            target="_blank"
            rel="noreferrer"
          >
            DURO,
          </a>{' '}
          <a href="https://tutulive.com/" target="_blank" rel="noreferrer">
            TUTU Records,
          </a>{' '}
          <a
            href="https://soundcloud.com/ransom-note-records/sets/graintable-universal-ash-1"
            target="_blank"
            rel="noreferrer"
          >
            Ransom Note,
          </a>{' '}
          <a
            href="https://blankstairs.bandcamp.com/"
            target="_blank"
            rel="noreferrer"
          >
            Blankstairs
          </a>{' '}
          and{' '}
          <a
            href="https://coast2ckm.bandcamp.com/track/mente-maleable?label=273540382&tab=music"
            target="_blank"
            rel="noreferrer"
          >
            Krater Music.
          </a>
        </p>
      </div>
    </>
  );
};

export default About;
